import {
  Box,
  Button,
  Flex,
  Field,
  Group,
  Heading,
  Input,
  Link,
  Stack,
  Text,
} from "@chakra-ui/react";
import { ArrowRight } from "lucide-react";
import { Link as ReactRouterLink } from "react-router-dom";
import { FakturLogo } from "./components/FakturLogo";
import { useSignupNewsletter } from "./hooks/useSignupNewsletter";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";

const schema = yup
  .object({
    email: yup.string().email().required(),
  })
  .required();

export default function Home() {
  const signupNewsletter = useSignupNewsletter();

  const {
    register,
    handleSubmit,
    formState: { errors: formStateErrors },
  } = useForm({
    mode: "onSubmit",
    resolver: yupResolver(schema),
  });
  const onSubmit = (data: { email: string }) => {
    return signupNewsletter.mutate(data);
  };
  return (
    <>
      <Box textAlign="center" p={10}>
        <Flex alignItems="center" justifyContent="center">
          <FakturLogo size={128} />
        </Flex>
      </Box>
      <Stack>
        <Text fontSize="xx-large" mb={8} textAlign="center">
          Fakturaer – enkelt. <br />
        </Text>
        <form onSubmit={handleSubmit(onSubmit)}>
          <Stack>
            <Box display="flex" justifyContent="center">
              <Stack direction="row" alignItems="center">
                <Heading size="md">Hold deg oppdatert!</Heading>
              </Stack>
            </Box>
            <Box display="flex" justifyContent="center">
              <Field.Root
                invalid={Boolean(formStateErrors["email"])}
                width={400}
              >
                <Field.Label fontSize={12}>
                  Ved å melde deg på godkjenner du vår{" "}
                  <Link asChild>
                    <ReactRouterLink
                      to="/privacy/"
                      style={{ textDecoration: "underline" }}
                    >
                      personvernserklæring
                    </ReactRouterLink>
                  </Link>
                </Field.Label>
                <Group>
                  <Input {...register("email")} placeholder="name@domain.xyz" />
                  <Button type="submit">
                    <ArrowRight />
                  </Button>
                </Group>
              </Field.Root>
            </Box>
          </Stack>
        </form>
      </Stack>
    </>
  );
}
